import { render, staticRenderFns } from "./BattleRegister.vue?vue&type=template&id=6a265f02&scoped=true"
import script from "./BattleRegister.vue?vue&type=script&lang=js"
export * from "./BattleRegister.vue?vue&type=script&lang=js"
import style0 from "./BattleRegister.vue?vue&type=style&index=0&id=6a265f02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a265f02",
  null
  
)

export default component.exports